import ProjectService from '../../project.service.js';
import { errorMessage, successMessage } from '@/utils/message.js';
const debounce = require('lodash.debounce');
export default {
  components: {
  },
  data () {
    return {
      projectId: '',
      bidId: '',
      confirmDealBookInfo: {},
      submitStatus: 'init',
      type1: ['1-2', '2-1', '2-2', '2-3', '1-1', '3-1', '7-1', '7-2', '4-1', '4-2', '4-3', '4-4'],
      type3: ['6-1'],
      dialogTableVisible: false,
      ruleForm: {
        remark: ''
      },
      rules: {
        remark: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      },
      citytitle: ''
    };
  },
  created () {
    const query = this.$route.query;
    this.projectId = query.projectId;
    this.bidId = query.bidId;
    if (this.projectId && this.bidId) {
      this.getConfirmDealBook();
    }
  },
  computed: {
  },
  methods: {
    goBack () {
      this.$router.back();
    },
    getConfirmDealBook () {
      ProjectService.getConfirmDealBookInfo({
        projectId: this.projectId,
        bidId: this.bidId
      }).then(res => {
        if (res && res.code === '0') {
          this.confirmDealBookInfo = res.data;
          this.confirmDealBookInfo.type = res.data.projectType + '-' + res.data.projectSubType;
        }
      });
    },
    // 放弃成交
    giveUp () {
      this.dialogTableVisible = true;
    },
    cancel () {
      this.dialogTableVisible = false;
    },
    dialogFormclick () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('确定要拒绝成交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 拒绝成交提交
    submit () {
      let params = {
        projectId: this.projectId,
        bidId: this.bidId,
        remark: this.ruleForm.remark
      };
      ProjectService.abandonTransactionBook(params).then(res => {
        if (res && res.code === '0') {
          this.dialogTableVisible = false;
          this.$alert('提交成功！', ' ', {
            confirmButtonText: '确定',
            callback: () => {
              this.$router.back();
            }
          });
        }
      });
    },
    confirmDealBook: debounce(function () {
      if (this.submitStatus === 'ongoing') { return; }
      this.$confirm('确定要确认成交书？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitStatus = 'ongoing';
        ProjectService.confirmDealBook(this.projectId, this.bidId).then(res => {
          if (res && res.code === '0') {
            this.submitStatus = 'success';
            successMessage('确认成功！');
            this.goBack();
          } else if (res && res.reason) {
            this.submitStatus = 'failed';
            errorMessage(res && res.reason);
          } else {
            this.submitStatus = 'failed';
            errorMessage('确认成交书失败');
          }
        }, (error) => {
          this.submitStatus = 'failed';
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          } else {
            errorMessage('确认成交书失败');
          }
        });
      }).catch();
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
